import styled from 'styled-components';

const LoaderContainer = styled.div`
  margin: 0 auto;
`;

export default LoaderContainer;
